import React, { Component } from "react";
import { connect } from "react-redux";
import InputComponent from "../../components/form/InputComponent";
import { css } from "aphrodite";
import SearchIcon from "@material-ui/icons/Search";
import _ from "lodash";
import { Button } from "react-bootstrap";
import { FilterList } from "@material-ui/icons";
import { registeredList } from "../../actions/registrasi_member/regist_member_action";
import {
  getRegisteredList,
  getRegisteredListError,
  getRegisteredListPending,
} from "../../reducers/registrasi_member/regist_member_reducer";
import { listHeaderStyles as styles } from "../../components/header/listHeaderStyles";

class HeaderRegistrasiMember extends Component {
  constructor(props) {
    super(props);
    this.handleChangeNama = this.handleChangeNama.bind(this);
  }

  delayedQuery = _.debounce((value) => {
    this.props.handleRefresh(value);
  }, 500);

  handleChangeNama(e) {
    if (e !== null) {
      this.setState({ nama: e.target.value });
      this.delayedQuery({ search: e.target.value });
    } else {
      this.setState({ nama: "" });
      this.delayedQuery({ search: "" });
    }
  }

  render() {
    return (
      <div className={css(styles.bar)}>
        <div className={css(styles.title)}>
          <h4 className={css(styles.titleText)}>
            Database Registrasi Member
          </h4>
        </div>
        <div className={css(styles.actions)}>
          <div className={css(styles.field)}>
            <InputComponent
              onChange={this.handleChangeNama}
              placeholder="Cari Nama"
              endIcon={SearchIcon}
              id="nama"
            />
          </div>
          <div className={css(styles.fieldNarrow)}>
            <Button
              size="md"
              className={css(styles.filterButton)}
              onClick={this.props.onShowModal}
            >
              <span>Filter</span>
              <FilterList
                fontSize="medium"
                style={{ paddingLeft: 3 }}
              />
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ registeredList }) {
  return {
    registeredList_pending: getRegisteredListPending(registeredList),
    registeredList_data: getRegisteredList(registeredList),
    registeredList_error: getRegisteredListError(registeredList),
  };
}

export default connect(mapStateToProps, { registeredList })(
  HeaderRegistrasiMember
);
